import { Text, Link } from '@cash-me/react-components'

import * as S from './styles'

export const list = [
  {
    id: '1',
    title: '1. Objetivo',
    content: (
      <>
        <Text size="body2" color="var(--colors-neutral-text-weak)">
          A CASHME SOLUÇÕES FINANCEIRAS SA (“CashMe” ou nós) foi criada para tornar o segmento de soluções financeiras
          mais prático e simples, com o auxílio da tecnologia, de forma a atender à grande parte do território
          brasileiro, com o oferecimento de serviço totalmente digital.
        </Text>
        <br />
        <Text size="body2" color="var(--colors-neutral-text-weak)">
          Nosso crédito é diferente do que você já conhece porque, com a gente, tudo é pensado no detalhe, para realizar
          seus planos e sonhos.
        </Text>
        <br />
        <Text size="body2" color="var(--colors-neutral-text-weak)">
          Além de sermos especialistas em oferecer serviços 100% digital com agilidade e qualidade, também nos
          preocupamos em zelar pela segurança e proteção de seus dados pessoais.
        </Text>
        <br />
        <Text size="body2" color="var(--colors-neutral-text-weak)">
          Em razão disso, elaboramos este Aviso de Privacidade para explicar, de forma simples e objetiva quais
          informações suas são coletadas, por qual motivo as coletamos, se as compartilhamos e com quem, bem como quais
          são seus direitos como titular de dados e como exercê-los junto à CashMe, com objetivo de demonstrar o nosso
          compromisso no tratamento dos seus dados pessoais com segurança, privacidade e transparência.
        </Text>
        <br />
        <Text size="body2" color="var(--colors-neutral-text-weak)">
          Abaixo, apresentaremos o nome do controlador de seus dados pessoais, responsável por zelar pela segurança,
          respeito a finalidade e transparência de suas informações pessoais:
        </Text>
        <br />
        <Text size="body2" weight="bold" color="var(--colors-neutral-text-weak)">
          CASHME SOLUÇÕES FINANCEIRAS SA.
          <br />
          CNPJ nº 34.175.529/0001-68
          <br />
          Endereço – Rua Olimpíadas, 242, Vila Olímpia, São Paulo/SP, CEP 04551-000
        </Text>
      </>
    )
  },
  {
    id: '2',
    title: '2. Abrangência',
    content: (
      <>
        <Text size="body2" color="var(--colors-neutral-text-weak)">
          Este Aviso de Privacidade se aplica a indivíduos que interagem com serviços da CashMe, incluindo, mas não
          limitados ao(s):
        </Text>
        <br />
        <S.List>
          <S.ListItem clean>
            2.1 <b>Prospects da CashMe:</b> pessoas naturais prospectadas ou que já tenham solicitado a contratação de
            um dos serviços ou produtos, mas que não tenham se tornado um cliente da CashMe até o momento.
          </S.ListItem>
          <S.ListItem clean>
            2.2 <b>Clientes da CashMe:</b> pessoas naturais, seja para você mesmo ou para sua pessoa jurídica, que
            efetivamente contratem, utilizem ou acessem um ou mais serviços ou produtos da CashMe.
          </S.ListItem>
          <S.ListItem clean>
            2.3 <b>Parceiro Comercial (CashMember):</b> pessoas naturais com empresa aberta (CNPJ) quem indicam clientes
            para a CashMe.
          </S.ListItem>
          <S.ListItem clean>
            2.4 <b>Candidatos a vagas de emprego na CashMe:</b> pessoas naturais que se candidatam as vagas de emprego
            abertas na CashMe.
          </S.ListItem>
          <S.ListItem clean>
            2.5 <b>Fornecedores/prestadores de serviços:</b> pessoas naturais que representam legalmente as empresas que
            fornecem serviços/produtos para a CashMe.
          </S.ListItem>
        </S.List>
      </>
    )
  },
  {
    id: '3',
    title: '3. Quais dados pessoais são coletados pela CashMe?',
    content: (
      <>
        <Text size="body2" color="var(--colors-neutral-text-weak)">
          Com o propósito de respeitar a sua privacidade, entendemos que todo e qualquer Tratamento de Dados Pessoais
          deve ser limitado ao mínimo necessário, pertinente e proporcional para permitir que seja realizada a
          finalidade pretendida.
        </Text>
        <br />
        <Text size="body2" color="var(--colors-neutral-text-weak)">
          Por isso, os Dados Pessoais que coletamos a seu respeito irão variar conforme a relação que você opte por
          estabelecer conosco, ou seja, de cliente, consumidor, fornecedor, prestador de serviço, visitante, parceiros,
          dentre outras.
        </Text>
        <br />
        <Text size="body2" color="var(--colors-neutral-text-weak)">
          Abaixo, agrupados em categorias, apresentamos os principais dados pessoais seus tratados por nós:
        </Text>
        <br />
        <S.List>
          <S.ListItem clean>
            3.1 <b>Informações de identificação:</b> como o seu nome, CPF, CNPJ, data de nascimento, filiação,
            dependentes, dados de certificado digital, estado civil, sexo, entre outros.
          </S.ListItem>
          <S.ListItem clean>
            3.2 <b>Informações que nos auxiliem a contatá-lo:</b> como endereço residencial, CEP, telefone fixo ou
            celular, WhatsApp, e-mails pessoal e/ou profissional;
          </S.ListItem>
          <S.ListItem clean>
            3.3 <b>Informações do imóvel a ser dado em garantia ou a ser financiado:</b> CEP, cidade, estado,
            logradouro, bairro, número, tipo de imóvel, se o imóvel dado em garantia é o mesmo em que se reside, se o
            imóvel encontra-se quitado, valor do financiamento, entre outros;
          </S.ListItem>
          <S.ListItem clean>
            3.4 <b>Informações financeiras:</b> como renda declarada e comprovante, renda familiar, histórico de
            crédito, valor pretendido de empréstimo, valor avaliado do imóvel, quantidade de parcelas, entre outros;
          </S.ListItem>
          <S.ListItem clean>
            3.5 <b>Informações profissionais:</b> como profissão, local de trabalho, tipo de trabalho (CLT, prestador de
            serviço, autônomo, etc.), cargo, histórico profissional, qualificação acadêmica, dentre outras;
          </S.ListItem>
          <S.ListItem clean>
            3.6 <b>Informações comportamentais:</b> como perfil de consumo ou profissional, score de crédito, entre
            outros;
          </S.ListItem>
          <S.ListItem clean>
            3.7 <b>Dados pessoais sensíveis:</b> Reconhecimento facial para assinatura dos contratos, apenas em casos
            específicos.
          </S.ListItem>
          <S.ListItem clean>
            3.8 <b>Atributos associados aos seus dispositivos eletrônicos:</b> como provedor de acesso, sistema
            operacional, navegador (tipo, versão, opções habilitadas e plug-ins instalados), configurações de vídeo
            (tamanho/resolução e quantidade de cores), data e hora do acesso e páginas vistas através de cookies;
          </S.ListItem>
          <S.ListItem clean>
            3.9 <b>Informações provenientes de terceiros:</b> informações compartilhadas por terceiros com a CashMe,
            como informações oriundas de Bureaus de créditos, que apresentam dados cadastrais, comportamentais e
            financeiros; e
          </S.ListItem>
          <S.ListItem clean>
            3.10 <b>Dados gerais:</b> ou seja, o conteúdo que você nos envia por livre e espontânea vontade, como
            depoimentos referentes à CashMe postados em perfis e páginas nas redes sociais, juntamente com seu nome e
            imagem (incluindo fotos de perfil).
          </S.ListItem>
        </S.List>
      </>
    )
  },
  {
    id: '4',
    title: '4. Como a coletamos seus dados pessoais?',
    content: (
      <>
        <Text size="body2" color="var(--colors-neutral-text-weak)">
          As informações que tratamos a seu respeito podem ter sido fornecidas diretamente por você à <b>CashMe</b> ou
          de forma indireta, quando obtemos por terceiros, de fontes pública ou mesmo coletadas de forma automática
          através de nosso site, Plataforma ou outros canais, conforme abaixo se indica.
        </Text>
        <br />
        <Text size="body2" weight="bold" color="var(--colors-neutral-text-weak)">
          FORNECIDAS DIRETAMENTE POR VOCÊ
        </Text>
        <br />
        <Text size="body2" color="var(--colors-neutral-text-weak)">
          Desde o início de sua interação conosco, você voluntariamente nos disponibiliza informações a seu respeito,
          por exemplo, quando nos contata por meio das redes sociais ou dos nossos canais de atendimento, quando do
          acesso para conhecer nossos produtos e serviços ofertados, ou, ainda, quando você se cadastra para participar
          de nosso processo seletivo.
        </Text>
        <br />
        <Text size="body2" weight="bold" color="var(--colors-neutral-text-weak)">
          FORNECIDAS POR TERCEIROS
        </Text>
        <br />
        <Text size="body2" color="var(--colors-neutral-text-weak)">
          Em casos específicos, nós também poderemos receber alguns Dados Pessoais seus através de terceiros. Por
          exemplo, de nosso time de consultores, de parceiro especializado em recrutamento e seleção, nossos prestadores
          de serviços e fornecedores, ou, ainda, poderemos receber informações de instituições financeiras,
          securitizadora, parceiros bancarizadores e bureaus de crédito.
        </Text>
        <br />
        <Text size="body2" weight="bold" color="var(--colors-neutral-text-weak)">
          AUTOMATICAMENTE
        </Text>
        <br />
        <Text size="body2" color="var(--colors-neutral-text-weak)">
          Em algumas situações, também poderemos coletar Dados Pessoais automaticamente dos dispositivos que você
          utiliza para acessar o nosso website e plataformas, como endereço IP do dispositivo utilizado para acessar os
          serviços ou produtos da CashMe; dados técnicos, como informações de URL, de conexão de rede e do provedor;
          registros de data e horário de ações. Essas informações nos auxiliam a gerar estatísticas de acesso e, assim,
          conhecer melhor o nosso público. Isso é importante para que possamos aperfeiçoá-lo cada vez mais e adequá-lo
          ao maior público possível. Alguns desses dados podem ser coletados por meio de cookies ou tecnologias
          similares, conforme explicaremos em tópico próprio.
        </Text>
        <br />
        <Text size="body2" weight="bold" color="var(--colors-neutral-text-weak)">
          DISPONÍVEIS PUBLICAMENTE
        </Text>
        <br />
        <Text size="body2" color="var(--colors-neutral-text-weak)">
          Há, também, a possibilidade de coletarmos informações suas que se encontrem disponibilizadas publicamente,
          incluindo, mas não se limitando a bases de dados de órgãos públicos (por exemplo, Receita Federal).
        </Text>
      </>
    )
  },
  {
    id: '5',
    title: '5. Por que tratamos seus dados pessoais',
    content: (
      <>
        <Text size="body2" color="var(--colors-neutral-text-weak)">
          Os Dados Pessoais são tratados pela <b>CashMe</b> para diversas finalidades. Abaixo apresentamos as principais
          hipóteses em que trataremos as suas informações:
        </Text>
        <br />
        <Text size="body2" color="var(--colors-neutral-text-weak)">
          <b>5.1 Executar um contrato que você tenha celebrado conosco ou realizar diligências pré-contratuais</b>-
          quando você é parte em um contrato com a <b>CashMe</b>, ou represente uma empresa em uma contratação, iremos
          tratar seus Dados Pessoais para análise das solicitações de empréstimo, avaliação do imóvel, cobranças de
          inadimplentes, cancelamento de empréstimo, envio do contrato para assinatura digital, realização de due
          diligence, entre outros. Ainda, os dados serão tratados para a manutenção de nossas relações comerciais com
          clientes, parceiros, fornecedores e outros, bem como para garantir a execução da operação desejada e
          viabilizar contratos de compras e prestação de serviços;
        </Text>
        <br />
        <Text size="body2" color="var(--colors-neutral-text-weak)">
          <b>5.2 Proteção, concessão e análise de crédito</b> – poderemos tratar seus Dados Pessoais para efetuar a
          análise de crédito e, se necessário, também poderemos consultar Dados Pessoais complementares a seu respeito
          com terceiros parceiros, bureaus de crédito e demais informações públicas;
        </Text>
        <br />
        <Text size="body2" color="var(--colors-neutral-text-weak)">
          <b>5.3 Evitar fraudes e zelar pela sua segurança</b> - poderemos tratar os seus dados pessoais para zelar pela
          segurança (e de terceiros) e para evitar e combater fraude de identificação, em especial durante sua
          solicitação de empréstimo, em que adotaremos medidas para confirmar autenticar sua identidade;
        </Text>
        <br />
        <Text size="body2" color="var(--colors-neutral-text-weak)">
          <b>5.4 Cumprir nossas obrigações legais ou regulatórias</b> - seus Dados Pessoais poderão ser utilizados para
          o atendimento das nossas obrigações dispostas em lei e/ou regulações de órgãos governamentais e de ordens ou
          requisições de autoridades fiscais, Poder Judiciário e/ou outra autoridade competente, como para fornecimento
          de informe de rendimento ao cliente, emissão de notas fiscais aos fornecedores, notificação sobre cessão de
          crédito, para apuração de denúncia e reclamações;
        </Text>
        <br />
        <Text size="body2" color="var(--colors-neutral-text-weak)">
          <b>5.5 Exercer direito em demandas judiciais, administrativas ou arbitrais</b> - mesmo após o término da sua
          relação conosco, poderemos tratar alguns de seus Dados Pessoais para exercer nossos direitos garantidos em
          lei, inclusive como prova em processos judiciais, administrativos ou arbitrais;
        </Text>
        <br />
        <Text size="body2" color="var(--colors-neutral-text-weak)">
          <b>5.6 Viabilizar atividades necessárias à nossa Organização</b> - com base no nosso legítimo interesse,
          também poderemos tratar os seus Dados Pessoais em atividades como consultar terceiros, para melhor adequação
          dos produtos e/ou serviços disponibilizados; elaborar relatórios da região dos usuários e operações
          realizadas, para personalizar os serviços, produtos e benefícios oferecidos, bem como a comunicação, a
          divulgação destes aos nossos clientes e possíveis clientes, bem como para a gestão e utilização de cookies;
        </Text>
        <br />
        <Text size="body2" color="var(--colors-neutral-text-weak)">
          <b>5.7 Publicidade</b> - poderemos utilizar os seus Dados Pessoais para criar segmentações de públicos-alvo e,
          assim, promover de forma mais adequada conteúdos atualizados de campanhas de marketing e de remarketing da{' '}
          <b>CashMe</b>. Nesta hipótese, a opção de exclusão de cadastro da nossa base estará sempre disponível ao final
          de cada comunicação que encaminharmos, sendo facultado a possibilidade de escolha em relação ao recebimento de
          informações como ofertas e novidades sobre nossas últimas tendências;
        </Text>
        <br />
        <Text size="body2" color="var(--colors-neutral-text-weak)">
          <b>5.8 Prospecção</b> – quando você interage conosco, por nossos inúmeros canais (formulário online, interação
          com campanhas publicitárias, entre outros) para solicitar simulação de empréstimo ou até mesmo para sanar
          dúvidas e saber demais informações sobre nossos produtos e serviços, nosso time especializado entrará em
          contato pela maneira que melhor lhe atender, ou seja, por e-mail, por contato telefônico, por WhatsApp ou
          demais meios de comunicação; e
        </Text>
        <br />
        <Text size="body2" color="var(--colors-neutral-text-weak)">
          <b>5.9 Recrutamento e seleção</b> - divulgamos nossas vagas em sites especializados, também recebemos
          currículos por meio de consultoria de recrutamento e por meio de nosso LinkedIn. Nessas situações, nós iremos
          tratar seus dados pessoais para analisar seu currículo, verificar as suas competências, informações
          curriculares e se você atende ou não aos requisitos específicos da vaga para a qual você aplicou, bem como
          para dar seguimento ao processo seletivo, quando for o caso, em situações como contato por telefone ou e-mail
          e agendamento de entrevistas.
        </Text>
        <br />
        <Text size="body2" color="var(--colors-neutral-text-weak)">
          A <b>CashMe</b> também poderá tratar dados pessoais por meio de autorização concedida por você, para as
          finalidades onde verificarmos necessário a autorização, com base na legislação aplicável.
        </Text>
      </>
    )
  },
  {
    id: '6',
    title: '6. O que são Cookies e como utilizamos?',
    content: (
      <>
        <Text size="body2" color="var(--colors-neutral-text-weak)">
          Cookies são arquivos de texto que podem ser armazenadas em seus dispositivos eletrônicos quando você visita o
          nosso website. A CashMe se utiliza desta ferramenta para diferentes finalidades, como gerar estatísticas de
          acesso, aprimorar a sua experiência em nossas interfaces / domínios, dentre outras. Agregados em grupos,
          abaixo listamos os tipos de cookies utilizados e suas finalidades:
        </Text>
        <br />
        <table>
          <thead>
            <tr>
              <th>Tipo de Cookie</th>
              <th>O que eles fazem?</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>Necessários/Essenciais</td>
              <td>
                São cookies essenciais para viabilizar o adequado funcionamento do nosso website, assim como para permitir
                que você faça uso de todas as funcionalidades disponíveis.
              </td>
            </tr>
            <tr>
              <td>Desempenho/Análise</td>
              <td>
                São cookies que nos ajudam a entender como os visitantes interagem com o nosso website, fornecendo
                informações sobre as áreas visitadas, o tempo de visita ao site e quaisquer problemas eventualmente
                encontrados.
              </td>
            </tr>
            <tr>
              <td>Funcionais</td>
              <td>
                São cookies que permitem lembremos das suas escolhas anteriores, como idioma de navegação. São
                responsáveis por proporcionar uma experiência personalizada.
              </td>
            </tr>
            <tr>
              <td>Marketing/Publicidade</td>
              <td>
                São cookies utilizados para fornecer mais conteúdo relevante e específico para os seus interesses. Podem,
                ainda, ser utilizados para apresentar publicidade com um maior direcionamento ou limitar o número que esta
                é veiculada. Também, permitem a medição da eficácia de uma campanha lançada.
              </td>
            </tr>
          </tbody>
        </table>
        <br />
        <Text size="body2" color="var(--colors-neutral-text-weak)">
          Contudo, Você não precisa se preocupar, pois os Cookies não danificam seu equipamento e/ou dispositivo
          eletrônico e podem ser facilmente desabilitados, configurando o navegador para recusar cookies. Nestes casos,
          as plataformas podem não operar corretamente, ou ocasionar demasiada demora para carregar os conteúdos.
        </Text>
        <br />
        <Text size="body2" color="var(--colors-neutral-text-weak)">
          Para mais informações sobre como proceder em relação à gestão dos cookies nos navegadores, disponibilizamos os
          links abaixo:
        </Text>
        <br />
        <S.List>
          <S.ListItem>
            <Link href="https://support.microsoft.com/pt-br/help/17442/windows-internet-explorer-delete-manage-cookies">
              Internet explorer
            </Link>
          </S.ListItem>
          <S.ListItem>
            <Link href="https://support.mozilla.org/pt-BR/kb/ative-e-desative-os-cookies-que-os-sites-usam">
              Mozilla Firefox
            </Link>
          </S.ListItem>
          <S.ListItem>
            <Link href="https://support.google.com/accounts/answer/61416?co=GENIE.Platform%3DDesktop&hl=pt-BR">
              Google Chrome
            </Link>
          </S.ListItem>
          <S.ListItem>
            <Link href="https://support.apple.com/pt-br/guide/safari/sfri11471/mac">Safari</Link>
          </S.ListItem>
          <S.ListItem>
            <Link href="https://support.microsoft.com/pt-br/help/4468242/microsoft-edge-browsing-data-and-privacy-microsoft-privacy">
              Microsoft Edge
            </Link>
          </S.ListItem>
          <S.ListItem>
            <Link href="https://help.opera.com/en/latest/web-preferences/#cookies">Opera Help</Link>
          </S.ListItem>
        </S.List>
        <br />
        <Text size="body2" color="var(--colors-neutral-text-weak)">
          Você também poderá optar por bloquear a utilização de cookies do Google Analytics a partir do seguinte link:{' '}
          <Link href="https://tools.google.com/dlpage/gaoptout">https://tools.google.com/dlpage/gaoptout.</Link>
        </Text>
        <br />
        <Text size="body2" color="var(--colors-neutral-text-weak)">
          Por fim, destacamos que os cookies necessários são essenciais para o normal funcionamento do nosso site, sendo
          que a oposição à utilização desta ferramenta poderá implicar na inutilização de sua experiência ou na
          suspensão de seu acesso.
        </Text>
      </>
    )
  },
  {
    id: '7',
    title: '7. Com quem a CashMe compartilha meus dados',
    content: (
      <>
        <Text size="body2" color="var(--colors-neutral-text-weak)">
          Os seus Dados Pessoais podem ser compartilhados com alguns destinatários para viabilizar nossas atividades,
          caso em que estará restrito ao mínimo adequado e necessário para o cumprimento de alguma das finalidades
          específicas e previamente informadas a você, como:
        </Text>
        <br />
        <S.List>
          <S.ListItem clean>
            <b>i. Para consultas sobre suas informações na base de dados do Sistema de Informações de Crédito (SCR);</b>
          </S.ListItem>
          <S.ListItem clean>
            <b>ii. Para avaliação do seu imóvel em garantia;</b>
          </S.ListItem>
          <S.ListItem clean>
            <b>iii. Com instituições responsáveis por cobrar o crédito decorrente de inadimplência;</b>
          </S.ListItem>
          <S.ListItem clean>
            <b>iv. Com instituições financeiras, securitizadora e bancarizadora;</b>
          </S.ListItem>
          <S.ListItem clean>
            <b>
              v. Com parceiros comerciais e fornecedores, no desenvolvimento e prestação de serviços voltados a você,
              desde que devidamente aprovadas pelos processos de segurança da CashMe;
            </b>
          </S.ListItem>
          <S.ListItem clean>
            <b>
              vi. Com terceiros parceiros, que nos apoiam em campanhas e demais ações publicitárias e para prospecção;
            </b>
          </S.ListItem>
          <S.ListItem clean>
            <b>
              vii. Com fornecedores de serviço e/ou infraestrutura e terceiros que contribuam para as atividades da
              CashMe, desde que devidamente aprovadas pelos processos de segurança;
            </b>
          </S.ListItem>
          <S.ListItem clean>
            <b>
              viii. Para cumprimento de obrigações legais a que estamos submetidos, podemos ter de vir a compartilhar
              dados com autoridades públicas ou órgãos oficiais, mediante solicitação ou previsão legal expressa;
            </b>
          </S.ListItem>
          <S.ListItem clean>
            <b>
              ix. No caso de transações e alterações societárias, movimentações societárias, como Fusão, Aquisição e
              Incorporação;
            </b>
          </S.ListItem>
          <S.ListItem clean>
            <b>x. Com empresas que compõe o grupo da CashMe; e</b>
          </S.ListItem>
          <S.ListItem clean>
            <b>
              xi. Com escritórios de advocacia externos, para atuação em demandas ou processos extrajudiciais,
              judiciais, administrativas ou arbitrais.
            </b>
          </S.ListItem>
        </S.List>
        <br />
        <Text size="body2" color="var(--colors-neutral-text-weak)">
          Em qualquer caso, o compartilhamento de dados pessoais observará todas as leis e regras aplicáveis, buscando
          sempre garantir a segurança dos dados e os padrões técnicos empregados no mercado.
        </Text>
        <br />
        <Text size="body2" color="var(--colors-neutral-text-weak)">
          Quando realizamos o compartilhamento de seus dados pessoais com parceiros, nós utilizamos de instrumentos
          contratuais para assegurar que qualquer terceiro que os receba garanta a eles a proteção adequada.
        </Text>
        <br />
        <Text size="body2" color="var(--colors-neutral-text-weak)">
          Nas situações em que o compartilhamento for com um terceiro localizado fora do Brasil, além de garantir a
          segurança e proteção dos dados pessoais por meio de contrato, a CashMe se valerá de uma das hipóteses legais
          de transferência internacional.
        </Text>
        <br />
      </>
    )
  },
  {
    id: '8',
    title: '8. Por quanto tempo a CashMe armazena meus dados',
    content: (
      <>
        <Text size="body2" color="var(--colors-neutral-text-weak)">
          Armazenamos seus dados pessoais em ambiente seguro e controlado durante o período em que você mantiver
          relações conosco, observando às diretrizes sobre padrões de segurança estabelecidas nas regulamentações
          aplicáveis.
        </Text>
        <br />
        <Text size="body2" color="var(--colors-neutral-text-weak)">
          É possível que seus Dados Pessoais sejam mantidos por um período adicional após o cancelamento/encerramento da
          sua relação conosco, para fins de cumprimento de obrigações legais ou regulatórias, auditorias, para o
          exercício regular de direitos em demandas administrativas, judiciais ou arbitrais.
        </Text>
        <br />
        <Text size="body2" color="var(--colors-neutral-text-weak)">
          Para determinar o período de retenção de seus dados pessoais, nos baseamos nos seguintes critérios:
        </Text>
        <br />
        <S.List>
          <S.ListItem clean>
            i. Se temos uma obrigação legal, contratual ou outra de reter dados pessoais, ou se são necessários para
            fins de investigação ou litígio; e
          </S.ListItem>
          <S.ListItem clean>ii. Se são necessários para manter registros comerciais e financeiros precisos.</S.ListItem>
        </S.List>
        <br />
        <Text size="body2" color="var(--colors-neutral-text-weak)">
          Os seus Dados Pessoais poderão ser eliminados imediatamente se solicitado, exceto se a retenção for
          expressamente autorizada por lei ou contrato. <b>Ver item 9.</b>
        </Text>
      </>
    )
  },
  {
    id: '9',
    title: '9.	Como protegemos seus dados e como você também poderá protegê-los',
    content: (
      <>
        <Text size="body2" color="var(--colors-neutral-text-weak)">
          Implementamos todas as medidas de segurança que estão ao nosso alcance para proteger os seus Dados Pessoais de
          acessos não autorizados e de situações acidentais ou ilícitas de destruição, perda, alteração, comunicação ou
          difusão.
        </Text>
        <br />
        <Text size="body2" color="var(--colors-neutral-text-weak)">
          Todo os Dados Pessoais coletados são acessados somente por profissionais e empresas parceiras devidamente
          autorizadas, respeitando os princípios de proporcionalidade, necessidade e relevância para os objetivos do
          nosso negócio, além do compromisso de confidencialidade e preservação da sua privacidade. Além dessas medidas
          organizacionais e de governança, adotamos diversas outras de natureza técnica que garantem ainda maior
          segurança aos seus dados pessoais.
        </Text>
        <br />
        <Text size="body2" color="var(--colors-neutral-text-weak)">
          Quando você utilizar nossas Plataformas é necessário realizar o processo de autenticação a cada login por meio
          de senha. É sua responsabilidade zelar pela sua senha e/ou serviço de autenticação, não repassando a
          terceiros, suas credenciais de entrada. Essa tecnologia também visa impedir que as informações sejam
          transmitidas ou acessadas por terceiros não autorizados.
        </Text>
        <br />
        <Text size="body2" color="var(--colors-neutral-text-weak)">
          Caso ocorra qualquer tipo de incidente de segurança que possa gerar risco ou dano relevante para nossos
          titulares de dados, comunicaremos os afetados e a Autoridade Nacional de Proteção de Dados acerca do ocorrido,
          em conformidade com o disposto na Lei Geral de Proteção de Dados.
        </Text>
      </>
    )
  },
  {
    id: '10',
    title: '10.	Quais são os direitos como titular e como exercê-los',
    content: (
      <>
        <Text size="body2" color="var(--colors-neutral-text-weak)">
          Nos orgulhamos de ser uma empresa que leva a sério os direitos dos titulares de dados pessoais. Por isso,
          garantimos que os direitos sobre seus Dados Pessoais previstos na lei (art. 18, Lei Federal n. 13.709/2018)
          possam ser plenamente exercidos, respeitados os limites aplicáveis, através do endereço de e-mail{' '}
          <Link href="mailto:dpo@cashme.com.br">dpo@cashme.com.br</Link>, os seguintes direitos:
        </Text>
        <br />
        <S.List>
          <S.ListItem clean>
            <b>i. acesso aos dados</b> - você pode requerer o acesso aos seus dados pessoais armazenados pela{' '}
            <b>CashMe</b>, bem como informações sobre possível o compartilhamento com terceiros.
          </S.ListItem>
          <S.ListItem clean>
            <b>ii. correção</b> - caso os dados pessoais estejam incorretos, incompletos ou desatualizados, você poderá
            realizar uma solicitação de correção ou atualização.
          </S.ListItem>
          <S.ListItem clean>
            <b>iii. eliminação de dados tratados com base no consentimento</b> - dados fornecidos mediante consentimento
            podem ser alvo de exclusão. Contudo, é possível que, mesmo após o requerimento de exclusão, alguns dados
            pessoais permaneçam armazenados, devido a obrigações legais ou para a proteção de interesses nossos ou de
            nossos clientes.
          </S.ListItem>
          <S.ListItem clean>
            <b>iv. oposição</b> - você pode se opor ao tratamento de seus dados pessoais por parte da <b>CashMe</b>, com
            fundamento em uma das hipóteses de dispensa de consentimento, em caso de descumprimento ao disposto na LGPD;
          </S.ListItem>
          <S.ListItem clean>
            <b>v. portabilidade</b> - para que você possa exercer a portabilidade de seus dados pessoais, podemos
            providenciar a você uma cópia de seus dados pessoais em formato de leitura comum.
          </S.ListItem>
          <S.ListItem clean>
            <b>vi. informação sobre o compartilhamento</b> - você pode saber quais são as entidades públicas e privadas
            com as quais a <b>CashMe</b> compartilha seus Dados Pessoais.
          </S.ListItem>
          <S.ListItem clean>
            <b>vii. informação sobre a possibilidade de não consentir</b> - você tem o direito de receber informações
            claras e completas sobre a possibilidade e as consequências de não fornecer consentimento, quando ele for
            solicitado pela <b>CashMe</b>.
          </S.ListItem>
          <S.ListItem clean>
            <b>viii. revogação do consentimento</b> - caso você tenha consentido com alguma finalidade de tratamento dos
            seus Dados Pessoais, você pode sempre optar por retirar o seu consentimento. Porém, é possível que em
            algumas exceções a <b>CashMe</b> seja impossibilitada de lhe prestar certos serviços, mas iremos avisá-lo
            quando isso ocorrer;
          </S.ListItem>
          <S.ListItem clean>
            <b>ix. decisão automatizada</b> – você pode solicitar pela revisão de decisões automatizadas que afetem seus
            interesses, incluídas as decisões destinadas a definir o seu perfil pessoal, profissional, de consumo e de
            crédito ou os aspectos de sua personalidade; e
          </S.ListItem>
          <S.ListItem clean>
            <b>x. anonimização, bloqueio ou eliminação</b> – você poderá solicitar pela anonimização, bloqueio ou
            eliminação de dados desnecessários, excessivos ou que, porventura, tenham sido tratados em desconformidade
            com a lei.
          </S.ListItem>
        </S.List>
        <br />
        <Text size="body2" color="var(--colors-neutral-text-weak)">
          Para sua segurança, sempre que você apresentar uma requisição para exercer seus direitos, a CashMe poderá
          solicitar algumas informações e/ou documentos complementares para que possamos comprovar a sua identidade,
          buscando impedir fraudes.
        </Text>
        <br />
        <Text size="body2" color="var(--colors-neutral-text-weak)">
          Em circunstâncias específicas, é possível que a sua requisição não seja atendida. Nestes casos, nós
          explicaremos os motivos que justificaram o não atendimento.
        </Text>
        <br />
        <Text size="body2" color="var(--colors-neutral-text-weak)">
          Requisições que envolvam dados pessoais e/ou documentos de outros titulares não serão atendidas, exceto
          mediante procuração, poder parental ou outra hipótese que autorize o exercício do direito de outro titular por
          você.
        </Text>
        <br />
        <Text size="body2" color="var(--colors-neutral-text-weak)">
          Por fim, nos comprometemos a responder todas as requisições em um prazo razoável e sempre em conformidade com
          a legislação aplicável.
        </Text>
        <br />
        <Text size="body2" color="var(--colors-neutral-text-weak)">
          Para exercer seus direitos, você poderá contatar conosco, pelo e-mail{' '}
          <Link href="mailto:dpo@cashme.com.br">dpo@cashme.com.br.</Link>
        </Text>
      </>
    )
  },
  {
    id: '11',
    title: '11.	Das alterações em nosso Aviso de Privacidade',
    content: (
      <>
        <Text size="body2" color="var(--colors-neutral-text-weak)">
          A CashMe reserva o direito de modificar, a qualquer momento o presente Aviso, especialmente para adaptá-las às
          eventuais alterações feitas em nosso site, seja pela disponibilização de novas funcionalidades, seja pela
          supressão ou modificação daquelas já existentes.
        </Text>
        <br />
        <Text size="body2" color="var(--colors-neutral-text-weak)">
          Data da atualização: 15/03/2024
        </Text>
      </>
    )
  },
  {
    id: '12',
    title: '12.	Regulamentação legal',
    content: (
      <>
        <Text size="body2" color="var(--colors-neutral-text-weak)">
          Lei nº 13.709, de 14 de Agosto de 2018 – Lei Geral de Proteção de Dados.
        </Text>
      </>
    )
  },
  {
    id: '13',
    title: '13.	DPO CashMe',
    content: (
      <table>
        <thead>
          <tr>
            <th>Contato</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>
              <Link href="mailto:dpo@cashme.com.br">dpo@cashme.com.br</Link>
            </td>
          </tr>
        </tbody>
      </table>
    )
  }
]
